import React from 'react';
import Time from '../../../Components/Formatting/Time';
import { getTitle } from '../../../Components/Formatting/Customer/Title';
import { getSubTitle } from '../../../Components/Formatting/Customer/Subtitle';
import Services from '../../../Components/Formatting/Services';
import { useCalendarContext } from '../Provider';
import { appointmentClasses } from '../../../Data/Calendar';
import { Draggable } from "@hello-pangea/dnd";
import { classNames, timeToPx } from '../../../Services/helpers';

const Appointment = ({appointment, index}) => {
    const {durationSized, setPreviewingAppointment, currentlyDragging, appointmentWidth, pxPerHour} = useCalendarContext();

    if (!appointment.job) {
        console.warn('Appointment without job', appointment);
        return null;
    }

    const draggableId = `${appointment.jobId}:${appointment.job.customerId}`;
    const draggable = currentlyDragging === null || currentlyDragging === draggableId;

    const classes = [
        'rounded-lg w-full overflow-hidden py-0 px-2',
        'min-h-6',
        appointmentClasses[appointment.status],
    ];
    const styles = {
        height: durationSized ? timeToPx(appointment.duration, pxPerHour) : 'auto',
        maxWidth: appointmentWidth
    }

    if (!draggable) {
        return <div className={classNames(...classes)} style={styles}>
            <Inner {...{appointment}} />
        </div>
    }

    return <Draggable key={appointment.jobId}
        draggableId={draggableId}
        index={index}
    >
        {(provided, snapshot) => {
            return <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                onClick={() => setPreviewingAppointment(appointment)}
                className={classNames(
                    ...classes,
                    snapshot.isDragging && 'border-solid rotate-3 shadow-lg',
                    !snapshot.isDragging && 'border-dashed',
                )}
                style={{...styles, ...provided.draggableProps.style}}
            >
                <Inner {...{appointment}} />
            </div>
        }}
    </Draggable>
}

const Inner = ({appointment}) => {
    return <span className="text-sm whitespace-nowrap">
        <strong className="w-[3rem] inline-block">
            <Time time={appointment.estimatedStartTime} empty="- : -" />
        </strong>
        <strong>{getTitle(appointment.customer) ?? 'No customer name'}<br /></strong>
        {getSubTitle(appointment.customer)}<br />
        <Services services={appointment?.job?.services} />
    </span>
}

export default Appointment;